import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";

import 'bootstrap/dist/css/bootstrap.min.css';
// After Bootstrap, so the green theme's overrides win.
import './theme/themeTokens.css';
import { setupAxiosInterceptors } from './setupAxiosInterceptors';
import { installAbOtpInterceptor } from './utils/abOtp';
import { initTheme } from './theme/theme';

setupAxiosInterceptors();
installAbOtpInterceptor();
// Before the first render, so the chosen theme never flashes blue.
initTheme();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
